import { Link } from "react-router-dom"
import { Space, Tag } from "antd"
import type { CatalogTemplate } from "../../../types/regulatory"
import { OwnershipTag, ReviewTag, ScopeTag } from "./CatalogUI"
export function TemplateTiles({ items, base }: { items: CatalogTemplate[]; base: string }) {
  return (
    <div className="reg-template-grid">
      {items.map((t) => (
        <Link className="reg-template-tile" key={t.uuid} to={`${base}/${t.uuid}`}>
          <div className="reg-template-tile-meta">
            <span aria-hidden="true">▤</span>
            <ReviewTag validated={t.validated} />
          </div>
          <h2>{t.name}</h2>
          <p className="reg-template-reference">{t.referenceText || "Référence non renseignée"}</p>
          {t.description && <p className="reg-template-description">{t.description}</p>}
          <Space wrap>
            <Tag>Version {t.sourceVersion}</Tag>
            {typeof t.pointCount === "number" && <Tag>{t.pointCount} points propres</Tag>}
            {typeof t.includeCount === "number" && <Tag>{t.includeCount} modules inclus</Tag>}
          </Space>
          <div className="reg-template-tile-footer">
            <Space wrap>
              <ScopeTag scope={t.scope} />
              <OwnershipTag template={t} />
              {t.archived && <Tag>Archivé</Tag>}
            </Space>
            <span>Consulter →</span>
          </div>
        </Link>
      ))}
    </div>
  )
}
